<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 w-full h-screen flex items-center justify-center bg-smoke-light"
      @click.self="emit('toggle-modal')"
    >
      <div
        class="relative w-full max-w-2xl bg-white shadow-lg rounded-lg xs:p-2 sm:p-4 md:p-8"
      >
        <button
          aria-label="close"
          class="absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4"
          @click.prevent="emit('toggle-modal')"
        >
          ×
        </button>
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    return { emit };
  },
  emits: ["toggle-modal"],
};
</script>

<style  scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>